import { Chip, Tooltip } from "@heroui/react";

const TOOLTIP_THRESHOLD = 12; // символов — выше этого показываем тултип

interface ChipWithTooltipProps {
  label: string;
  color?: "default" | "success" | "warning" | "danger" | "accent";
  variant?: "soft" | "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg";
}

export function ChipWithTooltip({
  label,
  color = "default",
  variant = "soft",
  size = "sm",
}: ChipWithTooltipProps) {
  const needsTooltip = label.length > TOOLTIP_THRESHOLD;

  const chip = (
    <Chip color={color} variant={variant} size={size}>
      {needsTooltip ? (
        <span className="scd-chip-truncate">{label}</span>
      ) : (
        label
      )}
    </Chip>
  );

  if (!needsTooltip) return chip;

  return (
    <Tooltip delay={0}>
      <Tooltip.Trigger>{chip}</Tooltip.Trigger>
      <Tooltip.Content placement="top">
        <p>{label}</p>
      </Tooltip.Content>
    </Tooltip>
  );
}
